// Core
import { Component } from 'react';
import { connect } from 'react-redux';

// Instruments
import { explainPrice } from '@otpusk/json-api/dist/dictionary';

const mapStateToProps = (state) => ({
    selectedCurrencyCode: state.ui.get('selectedCurrency'),
});

@connect(mapStateToProps)
export class Price extends Component {
    render () {
        const { selectedCurrencyCode, children: body, price } = this.props;
        const { converted, original } = explainPrice(price);
        const { value, currency } = selectedCurrencyCode === 'uah' || !original ? converted : original;
        const inverted = selectedCurrencyCode === 'uah' && original ? original : converted;

        return body(
            value && value.toLocaleString('ru', { style: 'decimal', maximumFractionDigits: 0 }),
            currency,
            {
                value:    inverted.value ? inverted.value.toLocaleString('ru', { style: 'decimal', maximumFractionDigits: 0 }) : null,
                currency: inverted.currency ? inverted.currency : null,
            }
        );
    }
}
